import axios from "axios";
import { useEffect, useState } from "react";
import SignatureModal from "../component/modal/signatureModal";
import { useContext } from "react";
import { AppContext } from "component/context";
import ScrollToDiv from "component/scrollToDiv";
import { useNavigate } from "react-router-dom";
import signplaceholder from "assets/modal/signplaceholder.png";
import { NotificationManager } from "react-notifications";

function PDFSignature() {
  const [img, setImg] = useState(null);
  const [img2, setImg2] = useState(null);
  const [open, setopen] = useState(false);
  const [update, setUpdate] = useState(false);
  const [divReference, setDivReference] = useState("");
  const [htmlString, setHtmlString] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [oneForAll, setOneForAll] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  let navigate = useNavigate();

  let urlString = window.location.href.split("/");
  let encodeId = urlString[urlString.length - 1];

  useEffect(() => {
    setLoading(true);
    setError("");
    axios
        .get(`/api/html/get/${encodeId}`)
        .then((res) => {
          setHtmlString(res?.data?.result?.htmlWithPlaceholders);
          setOneForAll(res?.data?.result?.oneForAll);
          setDisableFileUpload(res?.data?.result?.signUpload);
          // signUpload
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          setError(err.response);
          console.log(err.response);
        });
  }, []);

  useEffect(() => {
    if (oneForAll) {
      for (const btn of document.querySelectorAll(".btn")) {
        btn.style.backgroundColor = "transparent"
        var imgTag = document.createElement("img");
        imgTag.src = img.img;
        imgTag.style.width = "100%";
        btn.innerHTML = "";
        let div = btn.appendChild(imgTag);
        div.style.width = "100%";
        div.style.height = "100%";
        div.style.borderRadius = "10px";
        div.style.backgroundColor = "transparent"
      }
    } else {
      if (img && img.divRef) {
        img.divRef.style.backgroundColor = "transparent"
        img.divRef.innerHTML = "";
        var imgTag = document.createElement("img");
        imgTag.src = img.img;
        imgTag.style.width = "100%";
        let div = img.divRef.appendChild(imgTag);
        div.style.width = "100%";
        div.style.height = "100%";
        div.style.borderRadius = "10px";
        div.style.backgroundColor = "transparent";
      }
    }
  }, [img, update]);

  useEffect(() => {
    if (htmlString) {
      setTimeout(mybox, 100);
    }
  }, [htmlString]);

  function mybox() {
    // for (const btn of document.querySelectorAll(".btn")) {
    for (let i = 0; i < document.querySelectorAll(".btn").length; i++) {
      const btn = document.querySelectorAll(".btn")[i];
      let img = document.createElement("img");
      img.style.display = "none";
      img.style.width = "100%";
      img.style.height = "100%";
      img.className = "notsign";
      img.src = signplaceholder;
      img.setAttribute('data-img-id', Date.now()); // set a unique id for each img element
      if (btn.childNodes.length > 1 && btn.childNodes) {
        for (let j = 0; j < btn.childNodes.length; j++) {
          if (btn.childNodes[j].nodeName !== "#text") {
            btn.childNodes[j].remove();
            btn.appendChild(img);
          }
        }
      } else {
        btn.childNodes[0].remove();
        btn.appendChild(img);
      }


      btn.addEventListener("click", (evt) => {
        if (evt.target.tagName === "DIV") {
          setDivReference(evt.target);
        } else {
          setDivReference(evt.target.parentNode);
        }
        setopen(true);
      });
    }
  }

  const createHtml = () => {
    let signDiv = document.querySelectorAll(".notsign");

    if (signDiv.length) {
      NotificationManager.success("לא סיימתם לחתום על המסמך, לחצו על הבא כדי לעבור לחתימה הבאה");
      return;
    }

    setError("");
    setLoading(true);
    let innerHtml = document.getElementById("create-html-to-pdf");
    const template = document.createElement("template");
    template.innerHTML = htmlString;
    for (let i = 0; i < innerHtml.querySelectorAll(".btn").length; i++) {
      let signedDiv = innerHtml.querySelectorAll(".btn")[i];
      for (
          let j = 0;
          j < template.content.querySelectorAll(".btn").length;
          j++
      ) {
        let templateSignedDiv = template.content.querySelectorAll(".btn")[j];
        if (signedDiv.id === templateSignedDiv.id) {
          let imgTag = signedDiv.getElementsByTagName("img")[0];
          let imgURL = imgTag.src;
          imgURL = imgURL.replace("https://sign.kaveret.biz/", "http://localhost:3000/");
          imgTag.src = imgURL;
          templateSignedDiv.style.backgroundColor = "transparent"
          templateSignedDiv.style.border = "none";
          templateSignedDiv.style.borderRadius = "10px"
          templateSignedDiv.innerHTML = signedDiv.innerHTML;
          templateSignedDiv.style.backgroundColor = "transparent";
        }
      }
    }

    let html = `<!DOCTYPE html>
     <html lang="he">
      <body>
      ${template.innerHTML}
      </body>
      </html>`;

    let data = {
      requestID: encodeId,
      html: html,
    };
    axios
        .post('/api/html/signedPdf', data)
        .then((res) => {
          console.log(res?.data?.result?.pdfLink);
          setLoading(false);
          navigate("/signature/complete");
        })
        .catch((err) => {
          console.log(err);
          setError(err.response);
          setLoading(false);
        });
  };

  const [fun, setFun] = useContext(AppContext);

  useEffect(() => {
    setFun({ onSavePdf: createHtml });
  }, [img, htmlString]);

  if (loading) {
    return (
        <div className="">
          <div style={{ height: "100px" }}></div>
          <div style={{ height: "80vh" }} className="d-flex jc-center ai-center">
            <div className="loader"></div>
          </div>
        </div>
    );
  }


  if (error) {
    return (
        <div className="d-flex jc-center ai-center" style={{ height: "100vh" }}>
          <div className="thank-you text-center d-flex jc-center flex-row ai-center" >
            <div style={{ textAlign: "center", marginBottom: "200px" }}>
              <h1>הודעה</h1>
              <p>{error?.data?.message}</p>
            </div>
          </div>
        </div>
    );
  }

  return (
      <div className="App">
        <div style={{ height: "50px" }}></div>
        <div
            id="create-html-to-pdf"
            dangerouslySetInnerHTML={{ __html: htmlString }}
        />

        <div style={{ position: "sticky", bottom: 0, width: "100%", backgroundColor: "#fef8d2" }}>
          <ScrollToDiv />
        </div>

        <SignatureModal
            disableFileUpload={disableFileUpload}
            setUpdate={setUpdate}
            divReference={divReference}
            update={update}
            setImg={setImg}
            setImg2={setImg2}
            img={img}
            open={open}
            setopen={setopen}
            handleClose={() => {
              setopen(false);
            }}
        />
      </div>
  );
}

export default PDFSignature;
